import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PageThreeFormData } from "../models";

const schema = yup.object().shape({
  pulsePerMinute: yup.string(),
  respirationPerMinute: yup.string(),
  spo2: yup.string(),
  bloodPressure: yup.string(),
  bodyTemperature: yup.string(),
  height: yup.string(),
  weight: yup.string(),
  idealWeight: yup.string(),
  bmi: yup.string(),
  waistCircumference: yup.string(),
  headCircumference: yup.string(),
  medicalHistorySummary: yup.string(),
  lastMenstrualPeriod: yup.date().nullable(),
  allergyBracelets: yup.string(),
  postDischargeLivingConditions: yup.string(),
  dischargeLivingDesc: yup.string(),
  menstruationRegularity: yup.string(),
  firstMenstruationDate: yup.date().nullable(),
  pregnancySuspicion: yup.string(),
  menopauseSuspicion: yup.string(),
  genderIdentityAppropriate: yup.string(),
  genderIdentityDesc: yup.string(),
  vaginalSecretion: yup.string(),
  vaginalSecretionDesc: yup.string(),
  menstruationInfo: yup.string(),
  menstruationDesc: yup.string(),
  sexualHealthIssue: yup.string(),
  sexualHealthIssueDesc: yup.string(),
  menarcheAge: yup.string(),
  menopauseAge: yup.string(),
  gravida: yup.string(),
  para: yup.string(),
  abortion: yup.string(),
  livingChildren: yup.string(),
  deliveryMethod: yup.string(),
  contraceptiveMethod: yup.string(),
});

export const usePageThreeForm = () => {
  const formMethods = useForm<PageThreeFormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      firstMenstruationDate: null,
      lastMenstrualPeriod: null,
    },
  });

  const { handleSubmit } = formMethods;

  const normalizeData = (data: PageThreeFormData) => {
    const normalized = { ...data } as any;
    Object.keys(normalized).forEach((key) => {
      if (typeof normalized[key] === "string") {
        normalized[key] = normalized[key].trim();
      }
    });
    return normalized as PageThreeFormData;
  };

  const onSubmit = handleSubmit((data) => {
    console.log("Page Three Form Data:", normalizeData(data));
  });

  return {
    formMethods,
    onSubmit,
  };
};
